import React from 'react';

import { Grid } from '@material-ui/core';

import AgreementInfoCard from '../cards/AgreementInfoCard';
import AgreementStatusCard from '../cards/AgreementStatusCard';
import AgreementVersionCard from '../cards/AgreementVersionCard';
import { Agreement } from '../Agreement.interface';

export interface AgreementTabInfoProps {
  agreement: Agreement;
  onChange?: (agreement: Agreement) => void;
}

const AgreementTabInfo: React.FC<AgreementTabInfoProps> = ({
  agreement,
  onChange
}) => {
  // const [agreement, setAgreement] = useState(initialAgreement);

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={8}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {agreement && (
              <AgreementInfoCard agreement={agreement} onChange={onChange} />
            )}
          </Grid>
          {/* <Grid item xs={12}>
          </Grid> */}
        </Grid>
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {agreement && <AgreementStatusCard agreement={agreement} />}
          </Grid>
          <Grid item xs={12}>
            {agreement && <AgreementVersionCard agreement={agreement} />}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AgreementTabInfo;
